<template>
  <div>
    <div style="width: 100%;height:61px;background: #000;">
      <div style="width: 1730px;height: 60px; margin: 0 auto;">
        <!-- 导航栏 -->
        <Header
          v-if="this.identity !== ''"
          activeIndex="tasks"
          :userName="userName"
          :identity="identity"
          :teacherGroup="teacherGroup"
          :role="role"
        />
        <!-- 角色选择框 -->
        <div v-if="((this.teacherGroup & 1) === 1) && ((this.teacherGroup & 16) === 16)" style="width: 160px; margin: -46px 0 0 50px">
          <el-radio-group v-model="role" size="small" @change="handleChange">
            <el-radio-button :label="1" style="width: 80px;">平台老师</el-radio-button>
            <el-radio-button :label="2" style="width: 80px;">本班老师</el-radio-button>
          </el-radio-group>
          <div class="role_div">
            <div @click="changeRole(1)"></div>
            <div @click="changeRole(2)"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="task">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 常规任务 -->
        <el-tab-pane
          label="常规任务"
          name="first"
         v-if="
            this.identity.indexOf('teacher') >= 0 &&
              (this.teacherGroup  === 2  ||  this.teacherGroup === 4 || this.teacherGroup === 8 || (this.teacherGroup & 1 === 1 && this.teacherGroup & 16 === 16 && this.role === 1) === true)
          "
        >
          <!-- 导航栏下面的内容 -->
          <div style="display: flex">
            <!-- 时间、年级、地区、表格、分页 -->
            <div>
              <!-- 时间（单选框） -->
              <div class="select-border">
                <div>时间</div>
                <el-date-picker
                  v-model="dateValue"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 400px"
                >
                </el-date-picker>
              </div>
              <!-- 年级（复选框） -->
              <div class="select-border">
                <div>年级</div>
                <el-checkbox-button
                  v-model="isCheck1"
                  @change="handleCheckAllChange1"
                  style="border-left: 1px solid #dcdfe6"
                  label="全选"
                ></el-checkbox-button>
                <el-checkbox-group v-model="data.grade" @change="gradeChange">
                  <el-checkbox-button
                    v-for="grade in grades"
                    :label="grade"
                    :key="grade"
                    style="border-left: 1px solid #dcdfe6; margin: 3px 5px"
                    >{{ grade }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
              <!-- 地区（复选框） -->
              <div class="select-border">
                <div>地区</div>
                <el-checkbox-button
                  v-model="isCheck2"
                  @change="handleCheckAllChange2"
                  style="border-left: 1px solid #dcdfe6"
                  label="全选"
                ></el-checkbox-button>
                <el-checkbox-group
                  v-model="checkboxGroup"
                  @change="regionChange"
                  style="width: 1290px; height: 80px"
                >
                  <el-checkbox-button
                    v-for="(province, index) in provinceList"
                    :label="province"
                    :key="index"
                    style="
                      border-left: 1px solid #dcdfe6;
                      border-radius: 2px;
                      margin: 3px 5px;
                    "
                    >{{ province.shortname }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
              <!-- 标题 -->
              <div class="select-border" style="margin-top:15px">
                <div>标题</div>
                <el-input
                  v-model="data.title"
                  placeholder="请输入标题"
                  style="width: 320px"
                ></el-input>
                <div
                  style="
                    display: inline-block;
                    margin-left: 10px;
                    width: 200px;
                    height: 20px;
                    font-size: 14px;
                    color: #f00;
                  "
                >
                  多个标题请用分号隔开
                </div>
              </div>

              <!-- 搜索、重置按钮 -->
              <div>
                <el-button class="search-btn" type="primary" @click="search"
                  >搜索</el-button
                >
                <el-button class="reset-btn" type="primary" @click="reset" plain
                  >重置</el-button
                >
                <!-- <el-button class="search-btn" @click="search">搜索</el-button>
              <el-button class="reset-btn" @click="reset">重置</el-button> -->
              </div>
              <!-- table表格和分页 -->
              <div>
                <div style="height: 525px;width: 100%;border: 1px solid #fff;">
                <el-table
                  :data="
                    tableData &&
                      tableData.slice(
                        (pageNum - 1) * pageSize,
                        pageNum * pageSize
                      )
                  "
                  border
                  style="width: 100%; margin-top: 15px"
                  max-height="510"
                  row-class-name="routine_table_row"
                  @row-click="handColumnClick"
                  v-loading="routineLoading"
                  element-loading-text="数据加载中"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="任务类型"
                    width="260"
                    align="center"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="commit_time"
                    label="提交时间"
                    :formatter="dateFormat"
                    width="300"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="grade"
                    label="年级"
                    width="125"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="region"
                    label="地区"
                    width="125"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="correct_mode"
                    label="批改类别"
                    width="155"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="duration"
                    label="任务时限/小时"
                    width="140"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="标题"
                    width="240"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="110">
                    <template slot-scope="scope">
                      <el-button
                        @click="handColumnClick(scope.row)"
                        type="text"
                        size="small"
                        >预览</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                </div>
                <!-- 分页 -->
                <div class="control">
                  <el-pagination
                    :current-page="pageNum"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="pageTotal"
                    @current-change="handleCurrentChange"
                    style="width: 658px;text-align: center;"
                  >
                  </el-pagination>
                </div>
              </div>
              <!-- 对话框 -->
              <div>
                <el-dialog
                  :title="dialogTitle"
                  :visible.sync="dialogVisible"
                  width="45%"
                  :before-close="handleClose"
                  center
                >
                  <div
                    class="dg"
                    v-if="this.commit_type === '文本'"
                    style="
                      padding: 30px;
                      font-size: 20px;
                      line-height: 40px;
                      height: 400px;
                      overflow: auto;
                      word-break: normal;
                      white-space: pre-wrap;
                    "
                  >
                    {{ text }}
                  </div>
                  <div
                    class="dg"
                    v-if="this.commit_type === '图片'"
                    style="
                      padding: 30px;
                      font-size: 20px;
                      line-height: 40px;
                      height: 500px;
                      text-align: center;
                    "
                  >
                    <el-carousel height="500px">
                      <el-carousel-item v-for="(item, i) in imageList" :key="i">
                        <el-image :src="item"> </el-image>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="innerVisible = true"
                      >领取任务</el-button
                    >
                  </span>
                  <el-dialog
                    width="30%"
                    title="温馨提示"
                    :visible.sync="innerVisible"
                    append-to-body
                    top="35vh"
                  >
                    <div style="margin-left: 20px; font-size: 15px">
                      确定领取该任务吗？
                    </div>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="handleTwoClose()">取消</el-button>
                      <el-button type="primary" @click="handleTwoTo()"
                        >确认领取</el-button
                      >
                    </span>
                  </el-dialog>
                </el-dialog>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 审核任务 -->
        <el-tab-pane
          label="审核任务"
          name="second"
          v-if="this.identity.indexOf('auditor') >= 0"
        >
          <el-table
            :data="
              tableData2 &&
                tableData2.slice(
                  (pageNum2 - 1) * pageSize2,
                  pageNum2 * pageSize2
                )
            "
            border
            style="margin-top: 25px"
            max-height="620"
            v-loading="loading"
            element-loading-text="数据加载中"
            row-class-name="routine_table_row"
          >
            <el-table-column
              type="index"
              label="序号"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="type"
              label="待审任务类型"
              :formatter="workType"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="duration"
              label="任务时限/小时"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="correct_mode"
              label="批改类型"
              :formatter="correctType"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="corrector"
              label="批改人"
              
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              width="220"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="essay_text"
              label="正文"
              width="520"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="handClick(scope.row)"
                  type="text"
                  size="small"
                >
                  领取任务
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            :current-page="pageNum2"
            :page-size="pageSize2"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal2"
            @current-change="handleCurrentChange"
            style="margin: 20px 0 0 538px"
          >
          </el-pagination>
          <!-- 对话框 -->
          <div>
            <el-dialog
              width="30%"
              title="温馨提示"
              :visible.sync="innerVisible2"
              append-to-body
              top="35vh"
            >
              <div style="margin-left: 20px; font-size: 15px">
                是否领取该任务？
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handleTwoClose()">取消</el-button>
                <el-button type="primary" @click="handleTwoTo()"
                  >确认领取</el-button
                >
              </span>
            </el-dialog>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
const gradeOptions = ["七年级", "八年级", "九年级"];
import { home } from "@/api";
import moment from "moment";
//引入token解析包 jwt-decode
import jwt_decode from "jwt-decode";
// 引入header组件
import Header from "./header.vue";

export default {
  data() {
    return {
      // 存放变量
      role: 1,   // 1---平台老师   2---本班老师  默认为平台老师
      activeName: "",
      radio: 1,
      checkboxGroup: [],
      grades: gradeOptions,
      provinces: [],
      provinceList: [],
      dateValue: "",
      tableData: [],
      tableData2: [],
      pageNum: 1, //:current-page="pageNum"---当前页数
      pageSize: 10, //page-size="pageSize"---每页显示条目数
      pageNum2: 1,
      pageSize2: 10,
      pageTotal: 0, //:total="pageTotal"---总条目数
      pageTotal2: 0,
      dialogTitle: "",
      dialogVisible: false,
      innerVisible: false,
      innerVisible2: false,
      text: "",
      data: {
        grade: [],
        region: [],
        time: [],
        title: ""
      },
      isCheck1: true,
      isCheck2: true,
      articalId: "",
      reviewId: "", //审核任务传值id
      commit_type: "", // 常规任务--任务类型
      taskType: "", // 审核任务--任务类型
      // imageUrl: "",
      imageList: [],
      baseUrl: "", //匹配后台url
      tabType: "",
      identity: "",
      teacherGroup: 0,
      userName: "",
      routineLoading: false,
      loading: true
    };
  },
  components: {
    Header
  },
  mounted() {
    this.init();
  },
  created() {
    this.baseUrl = this.GLOBAL.BASE_URL;
  },
  methods: {
    changeRole (a) {
      if(this.role === 2 && a===1){
        this.$confirm('切换为平台老师后，能够领取作文，但无法批改自己班级学生的作文，是否继续？', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.role = 1;
          this.handleChange();
        })
      };
      if(this.role === 1 && a===2){
        this.$confirm('切换为本班老师后，只能批改自己班级学生的作文，无法领取作文，是否继续？', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.role = 2;
          this.handleChange();
        })
      };
    },
    handleChange(){
      // 每次切换角色时，先清空localStorage中的role，再重新赋值
      localStorage.removeItem("role");
      localStorage.setItem("role", this.role);
      if(this.role === 2){
        this.$router.push({ path: "/myTasks" });
      }
    },
    // 页面初始化接口
    init() {
      // 获取token，并解析
      let info = window.location;
      if (info.search) {
        // 将token存储在本地
        localStorage.setItem("token", info.search.substring(7));
        // 解析token
        let token = jwt_decode(info.search.substring(7));
        // 调用方法渲染页面
        this.handleInitialize(token);
      } else if (localStorage.getItem("token")) {
        let token = jwt_decode(localStorage.getItem("token"));
        this.handleInitialize(token);
        this.role = Number(localStorage.getItem('role'));
      } else {
        this.$message({
          message: "未登录，请重新登录",
          type: "warning",
          duration: 1000,
          onClose: res => {
            this.$router.push({ path: "/login" });
          }
        });
      }
    },
    // 解析token获取用户信息，调接口加载页面
    handleInitialize(token) {
      // 获取用户信息（用户名和用户身份）
      this.identity = token.identity;
      this.teacherGroup = token.teacher_group;
      this.userName = token.nickname;
      if (
        this.identity.indexOf("teacher") >= 0 ||
        this.identity.indexOf("ocr") >= 0
      ) {
        this.tabType = "常规任务";
        this.activeName = "first";
      }
      if (
        this.identity.indexOf("teacher") < 0 &&
        this.identity.indexOf("ocr") < 0 &&
        this.identity.indexOf("auditor") >= 0
      ) {
        this.tabType = "审核任务";
        this.activeName = "second";
        //页面初始化获取审核任务数据(只有审核员身份刚进来就展示表格内容)
        home
          .reviewTask()
          .then(res => {
            if (res.data.retcode === 0) {
              // 关闭loading
              this.loading = false;
              this.tableData2 = res.data.data;
              this.pageTotal2 = this.tableData2.length;
            } else if (res.data.retcode === 1 || res.data.retcode === 2) {
              this.$alert(res.data.retmsg, "登录异常", {
                confirmButtonText: "确定",
                callback: action => {
                  this.clearCache();
                }
              });
            } else {
              this.$alert(res.data.retmsg, "请求失败", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
      //页面初始化接口获取省份信息
      home
        .getprovice()
        .then(res => {
          if (res.data.retcode === 0) {
            // 从后台获取省份
            this.provinceList = res.data.data;
            // 遍历数组，单独拿到省份id再全部放入一个数组中
            this.provinceList.forEach(item => {
              this.provinces.push(item.id);
            });
          } else if (res.data.retcode === 1 || res.data.retcode === 2) {
            this.$alert(res.data.retmsg, "登录异常", {
              confirmButtonText: "确定",
              callback: action => {
                this.clearCache();
              }
            });
          } else {
            this.$alert(res.data.retmsg, "请求失败", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(err => {
          console.log("发生错误");
        });
    },

    // tabs点击事件
    handleClick(tab) {
      if (
        (this.identity.indexOf("teacher") >= 0 ||
          this.identity.indexOf("ocr") >= 0) &&
        tab.label === "审核任务"
      ) {
        //获取审核任务数据(多重身份)
        home
          .reviewTask()
          .then(res => {
            if (res.data.retcode === 0) {
              // 关闭loading
              this.loading = false;
              this.tableData2 = res.data.data;
              this.pageTotal2 = this.tableData2.length;
            } else if (res.data.retcode === 1 || res.data.retcode === 2) {
              this.$alert(res.data.retmsg, "登录异常", {
                confirmButtonText: "确定",
                callback: action => {
                  this.clearCache();
                }
              });
            } else {
              this.$alert(res.data.retmsg, "请求失败", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
      this.tabType = tab.label;
    },
    // 表格行操作 --常规任务
    handColumnClick(row) {
      this.commit_type = row.commit_type;
      this.articalId = row.id;
      this.imageList = []; //先将图片列表清空
      this.dialogVisible = true;
      this.dialogTitle = row.title; // 预览框标题
      this.text = row.essay_text;
      if (row.commit_type === "图片") {
        // 切割图片地址存储在imageList中
        // this.imageUrl = row.img_url;
        // this.imageList = this.imageUrl.split("|").map(item => {
        //   return this.baseUrl + item; //拼接获取完整的图片url，在页面展示图片
        // });
        // 获取图片地址
        row.img_url.map(item => {
          this.imageList.push(item);
        });
      }
    },
    // 表格行操作 --审核任务
    handClick(row) {
      this.innerVisible2 = true;
      this.taskType = row.type;
      this.articalId = row.id;
    },
    // 二次确认点击事件
    handleTwoTo() {
      if (this.tabType === "常规任务") {
        // 判断是否需要经过ocr识别(图片需要先到ocr页面进行识别)
        if (this.commit_type === "文本") {
          home
            .check({ id: this.articalId, mode: 0 })
            .then(res => {
              if (res.data.retcode === 0) {
                this.$router.push({
                  path: "correct",
                  query: { id: this.articalId, activeIndex: "tasks" }
                });
              } else if (res.data.retcode === 1 || res.data.retcode === 2) {
                this.$alert(res.data.retmsg, "登录异常", {
                  confirmButtonText: "确定",
                  callback: action => {
                    this.clearCache();
                  }
                });
              } else {
                this.$alert(res.data.retmsg, "请求失败", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
        if (this.commit_type === "图片") {
          home
            .ocrInitialize({ id: this.articalId, mode: 0 })
            .then(res => {
              if (res.data.retcode === 0) {
                // 判断是否需要经过ocr识别(图片需要先到ocr页面进行识别)
                this.$router.push({
                  path: "ocr",
                  query: { id: this.articalId, activeIndex: "tasks" }
                });
              } else if (res.data.retcode === 1 || res.data.retcode === 2) {
                this.$alert(res.data.retmsg, "登录异常", {
                  confirmButtonText: "确定",
                  callback: action => {
                    this.clearCache();
                  }
                });
              } else {
                this.$alert(res.data.retmsg, "请求失败", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
          // this.$router.push({
          //   path: "ocr",
          //   query: { id: this.articalId, mode: 0 }
          // }); //页面跳转到ocr识别页面
        }
        this.dialogVisible = false;
        this.innerVisible = false;
      }
      if (this.tabType === "审核任务") {
        if (this.taskType === "correct") {
          let data = {
            taskid: this.articalId,
            mode: 0
          };
          home
            .taskReview(data)
            .then(res => {
              if (res.data.retcode === 0) {
                this.$router.push({
                  path: "taskReview",
                  query: { id: this.articalId, mode: data.mode }
                });
              } else if (res.data.retcode === 1 || res.data.retcode === 2) {
                this.$alert(res.data.retmsg, "登录异常", {
                  confirmButtonText: "确定",
                  callback: action => {
                    this.clearCache();
                  }
                });
              } else {
                this.$alert(res.data.retmsg, "请求失败", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
        if (this.taskType === "ocr") {
          this.$router.push({
            path: "ocrReview",
            query: { id: this.articalId, mode: 0 }
          }); //页面跳转到批改审核面
        }
        this.innerVisible2 = false;
      }
    },
    handleTwoClose() {
      if (this.tabType === "常规任务") {
        this.dialogVisible = false;
        this.innerVisible = false;
      }
      if (this.tabType === "审核任务") {
        this.innerVisible2 = false;
      }
    },
    //任务类型列转为文字
    workType(row) {
      if (row.type === "correct") {
        return "作文批改";
      }
      if (row.type === "ocr") {
        return "OCR识别";
      }
    },
    //批改类型列转文字
    correctType(row) {
      if (row.correct_mode === 1) {
        return "机批";
      }
      if (row.correct_mode === 2) {
        return "粗批";
      }
      if (row.correct_mode === 3) {
        return "精批";
      }
    },
    //表格时间格式修改
    dateFormat(row, column, cellValue) {
      var fecha = require("fecha");
      return cellValue
        ? fecha.format(new Date(cellValue), "YYYY-MM-DD HH:mm:ss")
        : "";
    },
    handleCurrentChange(val) {
      if (this.tabType === "常规任务") {
        this.pageNum = val;
      }
      if (this.tabType === "审核任务") {
        this.pageNum2 = val;
      }
    },
    // 年级复选框选项发生变化时
    gradeChange(val) {
      if (val.length > 0) {
        this.isCheck1 = false;
      } else {
        this.isCheck1 = true;
      }
    },
    // 地区复选框选项发生变化时
    regionChange(val) {
      if (val.length > 0) {
        this.isCheck2 = false;
      } else {
        this.isCheck2 = true;
      }
    },
    // 年级不限按钮点击事件
    handleCheckAllChange1(val) {
      this.isCheck1 = val;
      if (val === true) {
        this.data.grade = [];
      }
    },
    // 地区不限按钮点击事件
    handleCheckAllChange2(val) {
      this.isCheck2 = val;
      if (val === true) {
        this.checkboxGroup = [];
        this.data.region = [];
      }
    },
    // 搜索框
    search() {
      if (this.checkboxGroup) {
        this.checkboxGroup.map(item => {
          this.data.region.push(item.id);
        });
      } else {
        this.data.region = [];
      }
      this.data.time = [];
      // this.data.title = '';
      if (this.dateValue) {
        let startTime = moment(this.dateValue[0].getTime()).format(
            "YYYY-MM-DD"
          ),
          endTime = moment(this.dateValue[1].getTime()).format("YYYY-MM-DD");
        this.data.time.push(startTime, endTime);
      }
      // 显示分页栏
      $(".control").css("display", "block");
      this.getRoutineTask();
    },
    // 重置
    reset() {
      // 隐藏分页栏
      $(".control").css("display", "none");
      this.checkboxGroup = [];
      this.dateValue = "";
      this.isCheck1 = true;
      this.isCheck2 = true;
      this.data.grade = [];
      this.data.title = "";
      this.tableData = [];
    },
    //  获取常规任务数据接口
    getRoutineTask() {
      this.routineLoading = true;
      home
        .getDetail(this.data)
        .then(res => {
          if (res.data.retcode === 0) {
            this.routineLoading = false;
            this.tableData = res.data.data;
            this.pageNum = 1;
            this.pageTotal = this.tableData.length;
          } else if (res.data.retcode === 1 || res.data.retcode === 2) {
            this.$alert(res.data.retmsg, "登录异常", {
              confirmButtonText: "确定",
              callback: action => {
                this.clearCache();
              }
            });
          } else {
            this.$alert(res.data.retmsg, "请求失败", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
          this.data.region = [];
        })
        .catch(err => {
          console.log(err, "发生错误");
        });
    },
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      this.$router.push({ path: "/login" });
    },
    // dialog关闭前的回调
    handleClose() {
      // 关闭对话框前先将滚动条移动到默认的起始位置
      $(".dg").scrollTop(0);
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped>
.role_div {
  display: flex;
  width: 165px;
  position: relative;
  top: -32px;left: 0;
  cursor: pointer;
}
.role_div div {
  width: 80px;
  height: 32px;
}
.el-tabs__item {
  font-size: 30px !important;
}
.task {
  width: 1560px;
  margin: 0 auto;
}
a {
  display: inline-block;
  width: 100%;
  height: 100%;
  text-decoration: none;
}
.select-border {
  display: flex;
  margin: 0px 15px 5px 5px;
  align-items: center;
}
.select-border div:first-child {
  margin-right: 15px;
  /* border: 1px solid #999; */
  border-radius: 5px;
  width: 110px;
  height: 38px;
  font-size: 16px;
  color: #777777;
  text-align: center;
  line-height: 38px;
}
.search-btn {
  margin: 0 50px 0 580px;
}
.search-btn,
.reset-btn {
  width: 120px;
  height: 45px;
  font-size: 16px;
}
.el-tooltip__popper {
  width: 80%;
}
.control {
  margin: 0px auto;
  width: 658px;
}
</style>
<style>
.routine_table_row td,
.routine_table_row th {
  padding: 6px 0;
}
.el-table tr.routine_table_row:hover > td {
  background: #66b1ff;
}
.el-table tr.routine_table_row:hover > td div button span {
  color: #fff;
}
.el-tooltip__popper {
  width: 80%;
}
/* 控制表格点击行高亮显示 */
.el-table__body tr.current-row > td {
  background-color: #66b1ff !important;
}
.el-tabs__item {
  font-size: 20px;
}
.el-tabs__active-bar {
  width: 80px;
}
</style>
